"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _default = {
  "castroreale": {
    "9df92b15": [{
      "hkey": "b7224cff",
      "slug": "porticato",
      "name": "Porticato",
      "primary": true,
      "skipSearch": false
    }],
    "porticato-molinoner": [{
      "hkey": "b7224cff",
      "slug": "porticato",
      "name": "Porticato",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": null
    }],
    "de28e5c7": [{
      "hkey": "61169a62",
      "slug": "castroreale",
      "name": "Castroreale",
      "primary": true,
      "skipSearch": false
    }],
    "serro-murga": [{
      "hkey": "61169a62",
      "slug": "castroreale",
      "name": "Castroreale",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }]
  }
};
exports["default"] = _default;